module.exports = __webpack_public_path__ + "img/danger.b3f112b0.png";